import { CoreAPI, createCommonAgreementMethods } from '@hero/sdk-core';

/**
 * Carrier-facing Agreement APIs. Same surface as customer-sdk for now —
 * the controller scopes by `org` / `superAdmin` automatically.
 */
export function createAgreementsAPI(coreAPI: CoreAPI) {
  return {
    ...createCommonAgreementMethods(coreAPI),
  };
}
